import dynamic from "next/dynamic";
import type { ReactNode } from "react";

export const BrowserWalletConnectionProvider = dynamic<{ children: ReactNode }>(
  () =>
    import("./WalletConnectionProvider").then(
      ({ WalletConnectionProvider }) => WalletConnectionProvider
    ),
  {
    ssr: false,
  }
);
